import { ModelBase } from 'store/model-base';

export class BillerDevice extends ModelBase {
    public static storeName: string = 'billerDevice';

    public id: Id;
    public imei: string;
    public iccId: string;
    public isCdma: boolean;
}
